import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { OilBlockDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-oil-block-view',
  templateUrl: './oil-block-view.component.html',
  styleUrls: ['./oil-block-view.component.css'],
})
export class OilBlockViewComponent implements OnInit {
  @Input() oilBlocks: OilBlockDto[];
  oilBlockForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<OilBlockDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  loading = true;
  LabelName: string;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.oilBlockForm = this.fb.group({ OilBlocks: this.fb.array([]) });
    this.setOilBlocks();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display oilBlocks
  setOilBlocks() {
    const control = this.oilBlockForm.controls.OilBlocks as FormArray;
    this.oilBlocks.forEach((e) => {
      control.push(
        this.fb.group({
          OilBlockName: e.OilBlockName,
          LabelName: e.LabelName,
          id: e.id,
        })
      );
    });
  }

  // method to add OilBlocks
  addOilBlock() {
    if (this.oilBlocks.length > 0) {
      this.LabelName = this.oilBlocks[0].LabelName;
    } else {
      this.LabelName = '';
    }
    const control = this.oilBlockForm.controls.OilBlocks as FormArray;
    control.insert(
      0,
      this.fb.group({
        OilBlockName: ['', Validators.required],
        LabelName: [this.LabelName],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete oilBlock from arrary list
  deleteOilBlock(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.oilBlockForm.controls.OilBlocks as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.oilBlocks.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.oilBlocks[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'oilBlock';
    this.changeEmit.emit(formValue);
    console.log('form ', formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('oilBlock');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
